








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class InputText extends Vue {
  @Prop(String) readonly value!: string
}
